export default __webpack_public_path__ + "static/media/Lambda.00d55bdc.png";